// extracted by mini-css-extract-plugin
module.exports = {"title":"__title__cXGq4","animate":"__animate__FgW1O","fade-in":"__fade-in___EFKj"};